import { render, staticRenderFns } from "./amapTF.vue?vue&type=template&id=386a2b5d&scoped=true&"
import script from "./amapTF.vue?vue&type=script&lang=js&"
export * from "./amapTF.vue?vue&type=script&lang=js&"
import style0 from "./amapTF.vue?vue&type=style&index=0&id=386a2b5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386a2b5d",
  null
  
)

export default component.exports